module.exports = __webpack_public_path__ + "static/img/room_titletwo1.e6195f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_titletwo1.png
// module id = tYjg
// module chunks = 0